<template>
  <div
    :id="id"
    class="chart"
  />
</template>

<script>
import * as echarts from 'echarts';
import moment from 'moment';
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    id: {
      type: String,
      default: 'id'
    },
    title: {
      type: String,
      default: 'id'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      chart: null,
      screenWidth: window.screen.width == 960? 6 : window.screen.width == 1280 || Math.floor(window.screen.width * window.devicePixelRatio) == 3840 ? 8 : 12
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getMax(_data, unit) {
      return Math.floor(Math.max.apply(null, _data)) + unit
    },
    getMin(_data, unit) {
      return Math.floor(Math.min.apply(null, _data)) - unit
    },
    //v: 当前数据，index: 当前索引，arr: 数据数组，unit: 单位
    formatValue(v,index,arr,unit) {
      let value = v[unit] > 0 ? v[unit].toFixed(2) : 0
      // 如果当前值为0，且前后值都不为0，则复制前一个点的值
      if (value <= 0 && index > 0 && index < arr.length - 1 && arr[index - 1][unit] > 0 && arr[index + 1][unit] > 0) {
        value = arr[index - 1][unit].toFixed(2);
      }
      // 如果最后一个元素为0，复制前一个元素的值
      if (index === arr.length - 1 && value === 0) {
        value = arr[index - 1][unit].toFixed(2);
      }
      return value
    },
    isValidTime(timeString) {
      const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      return regex.test(timeString);
    },
    initChart(dataList) {
      if (!this.chart) this.chart = echarts.init(document.getElementById(this.id))
      let timeData = dataList.map(v => {
        if(this.isValidTime(v.createTime)) {
          return v.createTime? moment(v.createTime, 'YYYY-MM-DD HH:mm:ss').format('MM-DD HH:mm') : v.createTime
        }else {
          return v.createTime
        }
      })
      //格式化数据，将值为0的数据替换成前一个点的数据
      let rateData = dataList.map((v,index,arr) => {
        return this.formatValue(v,index,arr,'unitEfficiency')
      })
      let fData = dataList.map((v,index,arr) => {
        return this.formatValue(v,index,arr,'comprehensiveEvaluation')
      })
      let waterData = dataList.map((v,index,arr) => {
        return this.formatValue(v,index,arr,'unitWaterRate')
      })
      //将格式化后值还为0的数据替换为null
      rateData = rateData.map(v => v == 0 ? null : v)
      fData = fData.map(v => v == 0 ? null : v)
      waterData = waterData.map(v => v == 0 ? null : v)
      //将值为null的数据移出数组
      let r = rateData.filter(item => item !== null);
      let f = fData.filter(item => item !== null);
      let w = waterData.filter(item => item !== null);
      //自适应y轴坐标
      let leftData = [...r, ...f]
      let max = this.getMax(leftData,5)
      let min = this.getMin(leftData,5)
      let rMax = this.getMax(w,4)
      let rMin = this.getMin(w,4)
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let tooltip = `
            <div>${params[0]?.name || ''}</div>
            <div>${params[0]?.marker || ''} ${params[0]?.seriesName || ''}：${params[0]?.value || ''}%<div>
              <div>${params[1]?.marker || ''} ${params[1]?.seriesName || ''}：${params[1]?.value || ''}<div>
                <div>${params[2]?.marker || ''} ${params[2]?.seriesName || ''}：${params[2]?.value || ''}m³/kW·h<div>
              `
            return tooltip
          }
        },
        grid: {
          top: '35%',
          left: '5%',
          right: '10%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#abd3ff'
            }
          },
          axisLabel: {
            fontSize: this.screenWidth
          },
          data: timeData,
          scale: true
        },
        yAxis: [{
          name: 'F值/机组效率',
          type: 'value',
          position: 'left',
          alignTicks: true,
          splitLine: {
            lineStyle: {
              color: 'rgba(22, 44, 65, 1)'
            }
          },
          max: max || 100,
          min: min || 0,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#abd3ff'
            }
          },
          axisLabel: {
            fontSize: this.screenWidth,
            formatter: function (value) {
              return value.toFixed(0)
            }
          },
          nameTextStyle: {
            fontSize: this.screenWidth
          }
        },
        {
          name: '耗水率',
          type: 'value',
          position: 'right',
          alignTicks: true,
          splitLine: {
            lineStyle: {
              color: 'rgba(22, 44, 65, 1)'
            }
          },
          max: rMax || 30,
          min: rMin || 0,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#abd3ff',
            }
          },
          axisLabel: {
            fontSize: this.screenWidth,
            formatter: function (value) {
              return value.toFixed(0)
            }
          },
          nameTextStyle: {
            fontSize: this.screenWidth
          }
        }
        ],
        series: [
          {
            name: '机组效率',
            type: 'line',
            symbolSize: 0,
            data: rateData,
            smooth: true,
            areaStyle: {
              opacity: 1,
              shadowBlur: 10,
              shadowColor: 'rgba(82, 85, 71, .5)',
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(82, 85, 71, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(82, 85, 71, .5)'
                }
              ])
            },
            itemStyle: {
              borderWidth: 20,
              color: '#e9de30', // 点的颜色
              lineStyle: {
                color: '#e9de30' // 线的颜色
              }
            },
            emphasis: {
              focus: 'series'
            },
          },
          {
            name: 'F值',
            type: 'line',
            symbolSize: 0,
            data: fData,
            smooth: true,
            areaStyle: {
              opacity: 1,
              shadowBlur: 10,
              shadowColor: 'rgba(45, 108, 136, .5)',
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(45, 108, 136, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(45, 108, 136, .5)'
                }
              ])
            },
            itemStyle: {
              borderWidth: 20,
              color: '#0eb7dc', // 点的颜色
              lineStyle: {
                color: '#0eb7dc' // 线的颜色
              }
            },
            emphasis: {
              focus: 'series'
            },
          },
          {
            name: '耗水率',
            type: 'line',
            symbolSize: 0,
            // stack: 'Total',
            data: waterData,
            smooth: true,
            areaStyle: {
              opacity: 1,
              shadowBlur: 10,
              shadowColor: 'rgba(172,207,255, .3)',
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(172,207,255, .3)'
                },
                {
                  offset: 1,
                  color: 'rgba(172,207,255, .2)'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              borderWidth: 20,
              color: '#accfff', // 点的颜色
              lineStyle: {
                color: '#accfff' // 线的颜色
              }
            },
            emphasis: {
              focus: 'series'
            },
          }
        ]
      })
    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  height: 100%;
}
</style>
